import FeatureKeys from "global/constants/FeatureKeys";
import { canCreateRequests, canViewRequests } from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

export const requestsSteps: TourStepConfig[] = [
  {
    id: "requests-create-folder",
    target: "requests.createFolder",
    title: "Organise requests into folders",
    content:
      "Group related requests — by client, by month, however you already work — so a long list stays navigable.",
    placement: "bottom",
    when: canCreateRequests,
  },
  {
    id: "requests-create-request",
    target: "requests.createRequest",
    title: "Create a request",
    content: (ctx) =>
      ctx.hasFeature(FeatureKeys.ENVELOPE_BULK_SEND)
        ? "Sign a document yourself, send it to others, or bulk send one document to a whole list of recipients."
        : "Sign a document yourself, or send it to others for signature.",
    placement: "left",
    when: canCreateRequests,
  },
  {
    id: "requests-filter",
    target: "requests.filter",
    title: "Search and filters",
    content:
      "Find a request by document or recipient, then narrow the list by status and created date.",
    placement: "bottom",
    when: canViewRequests,
  },
  {
    id: "requests-manage",
    target: "requests.list",
    title: "Everything you've sent",
    content:
      "Each request with its current status. Open one to see who has signed, send a reminder, or void it.",
    placement: "bottom",
    when: canViewRequests,
  },
];

export default requestsSteps;
